import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Social Media Walls</title>
        <meta
          name="description"
          content="Social Media Walls - Connect and share your content!"
        />
        <meta name="keywords" content="Social Media, Walls, Connect, Share" />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/icon/main-logo.png" />
      </Helmet>
      {/* Add a Link to the Login page */}
      <Link to="/login" className="btn btn-primary">
        Go to Login Page
      </Link>
    </div>
  );
};

export default Home;
